<template>
  <section class="parent">
    <div class="header">
      <div class="textParent">
        <h3 class="title">{{ $t('city_template.info_title') }}</h3>
        <p class="description">{{ $t('city_template.info_description') }}</p>
      </div>
      <div class="contact">
        <div class="yellowLine" />
        <div class="contactContent">
          <h4 class="contactTitle">
            {{ $t('city_template.info_contact_title') }}
          </h4>
          <p class="contactDescription">
            {{ $t('city_template.info_contact_text') }}
          </p>
          <div class="Flex marginTop">
            <img src="~@/assets/netherlands/contact-ic.svg" />
            <a
              :href="`mailto:${$t('city_template.info_email')}`"
              class="emailLink"
              >{{ $t('city_template.info_email_button') }}</a
            >
          </div>
          <div class="ContactItems">
            <div class="Flex columnGap emailContainer">
              <img src="~@/assets/netherlands/mail-ic.svg" />
              <h3>{{ $t('city_template.info_email') }}</h3>
            </div>
            <div class="Flex phoneContainer columnGap">
              <img src="~@/assets/netherlands/phone-ic.svg" />
              <h3>
                {{ $t('city_template.info_phone') }}
                <p>{{ $t('city_template.info_contact_hours') }}</p>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Features">
      <Feature
        v-for="(feature, index) in features"
        :key="index"
        :svgPath="feature.svgPath"
        :title="feature.title + (index + 1)"
        :text="feature.text + (index + 1)"
      />
    </div>
  </section>
</template>

<script>
import Feature from './Feature.vue';
import features from './data';

export default {
  components: { Feature },
  data() {
    return {
      features,
    };
  },
};
</script>

<style scoped>
.parent {
  margin: 0 var(--global-open-market-margin) 100px
    var(--global-open-market-margin);
}
.header {
  margin-bottom: 60px;
}
.title {
  font: normal normal bold 30px/40px Foco;
  letter-spacing: 0px;
  color: #2b4047;
  margin-top: 100px;
  margin-bottom: 24px;
}
.description {
  font: normal normal normal 16px/22px Lato;
  letter-spacing: 0.16px;
  color: #41565d;
}
.description {
  font: normal normal normal 16px/22px Lato;
  letter-spacing: 0.16px;
  color: #41565d;
}
.contactTitle {
  font-size: 20px;
  font-family: Lato;
  font-weight: bold;
  letter-spacing: 0px;
  color: #2b4047;
}
.contactDescription {
  font: normal normal normal 14px/20px Lato;
  letter-spacing: 0px;
  color: #2b4047;
}
.contact {
  display: grid;
  grid-template-columns: auto 1fr;
  margin-top: 55px;
}
.yellowLine {
  grid-column: 1;
  height: 100%;
  width: 8px;
  background: #ffdf22;
  border-radius: 8px;
}
.contactContent {
  padding: 1em;
}
.emailLink {
  background: #ffdf22 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 6px #00000029;
  border: 1px solid #ffdf22;
  border-radius: 40px;
  padding: 1em;
  align-self: center;
}
.emailLinkText {
  font: normal normal bold 16px/21px Lato;
  letter-spacing: 0.32px;
  color: #2b4047;
  text-transform: uppercase;
}
.Flex {
  display: flex;
}
.columnGap {
  column-gap: 10px;
}
.ContactItems {
  margin-top: 2em;
}
.phoneContainer {
  margin-top: 1em;
}
.phoneContainer img {
  align-self: flex-start;
}
.marginTop {
  margin-top: 2em;
}
@media (min-width: 768px) {
  .Features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    column-gap: 5%;
  }
  .header {
    display: grid;
    grid-template-columns: 1fr auto;
  }
  .textParent {
    max-width: 90%;
  }
  .title {
    font-size: 70px;
    line-height: 1;
  }
  .description {
    margin-top: 30px;
    font-size: 20px;
  }
  .emailLink {
    font: normal normal bold 20px/22px Lato;
    letter-spacing: 0.4px;
    color: #2b4047;
    margin-left: 2em;
  }
  .contactContent {
    padding: 0 2em;
  }
  .ContactItems {
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    column-gap: 2em;
    color: #2b4047;
  }
  .phoneContainer {
    margin-left: 1em;
    grid-column: 1;
    grid-row: 1;
  }
  .emailContainer {
    grid-column: 2;
    grid-row: 1;
  }
}

@media (min-width: 1024px) {
  .textParent {
    max-width: 90%;
  }
}

@media (min-width: 1400px) {
  .textParent {
    max-width: 83%;
  }
}
</style>
